import * as React from 'react';
export const IndicatorTriangle = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12 4l12 15.588H0L12 4z" />
  </svg>
);
